var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.gridColHeight')
    }
  }, [_c('el-input', {
    staticClass: "hide-spin-button",
    attrs: {
      "type": "number",
      "min": "0"
    },
    nativeOn: {
      "input": function($event) {
        return _vm.inputNumberHandler.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.optionModel.colHeight),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "colHeight", $$v)
      },
      expression: "optionModel.colHeight"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbf53234","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-grid/colHeight-editor.vue
// module id = null
// module chunks = 